<template>
  <div>
    <bread-crumb></bread-crumb>
    <div class="tipHeader" v-if="showTipHeader">
      <div>历史视频可同步到京东，将获得更多展示机会，登录dr.jd.com可查看</div>
      <div class="tipBtns">
        <span type="text" @click="handleSync"> 同步 </span>
        <span type="text" @click="handleDesync"> 不同步 </span>
        <div class="closeBtn" @click="handleDailyCancel">x</div>
      </div>
    </div>
    <div class="content-manage">
      <div class="content-manage-header">
        <el-input
          v-model="articleId"
          placeholder="请输入文章ID"
          size="mini"
          class="content-manage-header-input"
          @change="searchId"
        />
        <el-input
          v-model="title"
          placeholder="请输入文章标题"
          size="mini"
          class="content-manage-header-input"
          @change="searchTitle"
        />
        <el-select
          v-model="articleType"
          placeholder="全部类型"
          size="mini"
          class="content-manage-header-type"
          @change="changeType"
        >
          <el-option
            v-for="item in ArticleTypeList"
            :key="item.articleType"
            :label="item.name"
            :value="item.articleType"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="auditStatus"
          placeholder="全部状态"
          size="mini"
          class="content-manage-header-type"
          @change="changeStatus"
        >
          <el-option
            v-for="item in ArticleStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-cascader
          size="mini"
          v-model="contentIndexIds"
          collapse-tags
          placeholder="全部索引"
          class="content-manage-header-type"
          :props="indexProps"
          :options="indexTreeList"
          @change="handleChange"
        ></el-cascader>
        <el-date-picker
          style="margin-left: 10px; min-width: 350px; margin-right: 10px"
          size="mini"
          type="datetimerange"
          v-model="time"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectChenge"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          clearable
        >
        </el-date-picker>
        <el-select
          v-model="contentAttributes"
          placeholder="内容质量"
          size="mini"
          class="content-manage-header-type"
          @change="changenture"
          value-key="code"
        >
          <el-option
            v-for="item in qualityList"
            :key="item.code"
            :label="item.desc"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-button
          size="mini"
          class="content-manage-header-button"
          @click="resetSelectVal"
          >重置</el-button
        >
      </div>
      <div class="content-manage-list">
        <div class="content-manage-list-table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="id" label="文章ID"> </el-table-column>
            <el-table-column prop="title" label="文章标题"> </el-table-column>
            <el-table-column prop="articleType" label="文章类型">
              <template slot-scope="scope">
                <p>{{ scope.row.articleType | articlesType }}</p>
              </template>
            </el-table-column>
            <el-table-column label="索引类型">
              <template slot-scope="scope">
                <p>
                  {{
                    scope.row.contentIndexes.length > 0
                      ? scope.row.contentIndexes[
                          scope.row.contentIndexes.length - 1
                        ].name
                      : "-"
                  }}
                </p>
              </template>
            </el-table-column>
            <!-- 内容质量 -->
            <el-table-column label="内容质量" prop="contentAttributes">
              <template #header>
                <div>
                  <span>内容质量</span>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="内容质量来源于内容的基本素质和用户反馈等维度，“优秀”将获得更多的曝光机会"
                    placement="bottom-start"
                  >
                    <img
                      src="@/assets/mark.svg"
                      style="width: 15px; height: 15px"
                    />
                  </el-tooltip>
                </div>
              </template>
              <template slot-scope="scope">
                <div v-for="item in scope.row.contentAttributes" :key="item.id">
                  <span v-if="item.type == 29">{{ item.desc }}</span>
                </div>
              </template>
            </el-table-column>
            <!-- 总浏览量 -->
            <el-table-column prop="pv" label="总浏览量"> </el-table-column>

            <el-table-column label="发布时间" prop="submitTime">
            </el-table-column>
            <el-table-column prop="articleStatus" label="状态">
              <template slot-scope="scope">
                <p>
                  {{ scope.row.articleStatus | articleStatus() }}
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.rejectReason"
                    placement="top-start"
                    v-if="scope.row.articleStatus == 4"
                  >
                    <span class="el-icon-warning-outline"></span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="isTop" label="是否置顶">
              <template slot-scope="scope">
                <p>
                  {{ scope.row.isTop === 1 ? '已置顶' : '未置顶'}}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              align="left"
              label="操作"
              width="220"
            >
              <template slot-scope="scope">
                <el-button
                  @click="articlePreview(scope.row)"
                  type="text"
                  size="small"
                  v-if="scope.row.articleStatus !== 5"
                  >{{
                    scope.row.articleStatus == 3 ? "查看线上" : "预览"
                  }}</el-button
                >
                <span
                  class="border"
                  v-if="scope.row.articleStatus === 3"
                ></span>
                <el-button
                  type="text"
                  size="small"
                  @click="topWriterArticle(scope.row)"
                  v-if="scope.row.articleStatus === 3"
                  >{{ scope.row.isTop === 1 ? "取消置顶" : "置顶" }}
                </el-button>
                <!-- v-if="scope.row.articleStatus === 4 || scope.row.articleStatus === 5 || scope.row.articleStatus === 8 " -->
                <span
                  class="border"
                  v-if="
                    scope.row.articleStatus === 1 ||
                    scope.row.articleStatus == 4
                  "
                ></span>
                <!-- <el-button type="text" size="small" @click="articleAlter(scope.row)" v-if="scope.row.articleStatus === 4 || scope.row.articleStatus === 5 || scope.row.articleStatus === 8 ">修改</el-button> -->
                <el-button
                  type="text"
                  size="small"
                  @click="articleAlter(scope.row)"
                  v-if="
                    scope.row.articleStatus == 1 ||
                    scope.row.articleStatus == 4 ||
                    scope.row.articleStatus == 5
                  "
                  >修改</el-button
                >
                <span
                  class="border"
                  v-if="scope.row.articleStatus === 3"
                ></span>
                <el-button
                  type="text"
                  size="small"
                  @click="applyOfflineForPinBut(scope.row)"
                  v-if="scope.row.articleStatus === 3"
                  >申请下线</el-button
                >
                <span
                  class="border"
                  v-if="scope.row.articleStatus === 7"
                ></span>
                <el-button
                  type="text"
                  size="small"
                  @click="cancelApplyOfflineForPinBut(scope.row)"
                  v-if="scope.row.articleStatus === 7"
                  >撤销申请下线</el-button
                >
                <span
                  class="border"
                  v-if="scope.row.articleStatus === 2"
                ></span>
                <el-button
                  type="text"
                  size="small"
                  @click="cancelApplyArticleForPinBut(scope.row)"
                  v-if="scope.row.articleStatus === 2"
                  >撤销投稿</el-button
                >
                <span
                  class="border"
                  v-if="scope.row.articleStatus === 1"
                ></span>
                <el-button
                  type="text"
                  size="small"
                  class="delete"
                  @click="deleteDraftForPinBut(scope.row)"
                  v-if="scope.row.articleStatus === 1"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="content-manage-list-page">
          <pagination
            @sizePageChange="paginationChangeProduct"
            :paginationDatas="paginationDataProduct"
          >
          </pagination>
        </div>

        <modal
          :isShow.sync="dialogPreVisible"
          :title="dialogTitles"
          :btnText="btnText"
          :isShowBtn="isShowBtn"
          :width="dialogWidth"
        >
          <div class="content paddingLeft">
            <p class="before-content-color title">
              <span class="before-icon"></span> 移动端链接
            </p>
            <div class="image">
              <div class="flexs middle-a dialog-btns middle-a">
                <el-input
                  class="dialog-input"
                  v-model="mUrl"
                  placeholder="请输入移动端链接"
                ></el-input>
                <el-button class="color" type="text" size="small"
                  ><a :href="mUrl" target="_blank">打开</a></el-button
                >
                <el-button type="text" size="small" @click="copyUrl(mUrl)"
                  >复制</el-button
                >
              </div>
              <p class="dislog-sub-title">
                *预览页面不可用于商业用途，链接有效时间5分钟，超时过期请重新打开预览弹窗！
              </p>
              <div class="qrCode">
                <img :src="qrCode" alt="二维码图片" />
              </div>
              <div class="img-des">扫描二维码手机查看</div>
            </div>
          </div>
        </modal>
        <!-- <p>原创是指自己写的或团队自制、独立完成的作品，并对该内容有合法版权。抄袭或剽窃他人作品，汇总再编辑的文章，营销推广的内容，非独家授权或代理的作品，都不算原创内容。</p>
        <p>作者对内容的真实性、准确性负责，拥有内容中展示照片的合法版权。产生的后果作者需全部自行承担。</p> -->
        <!-- <div slot="footer" class="dialog-footer btns">
          <el-button type="primary" @click="originalTips=false">我知道了</el-button>
        </div>
      </el-dialog> -->
        <modal
          :isShow.sync="deletearticleDialog"
          title="删除草稿"
          :btnText="DialogBtn"
          :isShowBtn="ShowBtn"
          :width="Width"
          @clickHandler="deleteclickHandler"
        >
          <div class="content-main">是否确认删除</div>
        </modal>
        <!--  -->
        <modal
          :isShow.sync="offLinearticleDialog"
          title="下线"
          :btnText="DialogBtn"
          :isShowBtn="ShowBtn"
          :width="Width"
          @clickHandler="offLineclickHandler"
        >
          <!-- <el-form label-position="top" label-width="80px" :model="formLabelAlign">
          <el-form-item label="下线理由"> -->
          <div class="dialog-conter">
            <div class="dialog-header">下线理由</div>
            <el-input
              class="dialog-conter-conter"
              type="textarea"
              size="medium"
              placeholder="请输入下线理由"
              v-model="formLabelAlign.offLineValue"
              maxlength="120"
              show-word-limit
            >
            </el-input>
          </div>
          <!-- </el-form-item>
        </el-form> -->
        </modal>
        <!--  -->
        <modal
          :isShow.sync="repealarticleDialog"
          title="撤销投稿"
          :btnText="DialogBtn"
          :isShowBtn="ShowBtn"
          :width="Width"
          @clickHandler="repealclickHandler"
        >
          <div class="content-main">是否撤销投稿</div>
        </modal>
        <!--  -->
        <modal
          :isShow.sync="repealoffLinearticleDialog"
          title="撤销下线申请"
          :btnText="DialogBtn"
          :isShowBtn="ShowBtn"
          :width="Width"
          @clickHandler="repealoffLineclickHandler"
        >
          <div class="content-main">是否撤销下线申请</div>
        </modal>
        <modal
          :isShow.sync="showSyncDialog"
          title="同步到京东"
          :btnText="DialogBtn"
          :isShowBtn="ShowBtn"
          :width="Width"
          @clickHandler="syncClickHandler"
        >
          <div class="content-main">历史视频将同步到京东</div>
        </modal>
        <modal
          :isShow.sync="showDesyncDialog"
          title="不同步到京东"
          :btnText="DialogBtn"
          :isShowBtn="ShowBtn"
          :width="Width"
          @clickHandler="desyncClickHandler"
        >
          <div class="content-main">历史视频将不同步到京东</div>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "../../../../components/pagination";
import modal from "../../../../components/modal";
import {
  listAllArticleTypes,
  pageArticlesByPin,
  getPreviewInfoByIdForPin,
  applyOfflineForPin,
  listArticleTypesByPin,
  deleteDraftForPin,
  cancelApplyOfflineForPin,
  cancelApplyArticleForPin,
  queryDictionaries,
  queryWriterHisSyncConfirm,
  queryContentUserMapping,
  saveSyncState,
  topWriterArticle,
} from "@/api/user.js";
import breadCrumb from "../../../../components/breadCrumb";
import QRCode from "qrcode";
import { writerContentIndexTree } from "@/api/indexs";
import labelGroupVue from "../../../man/pages/labelManage/commonLabel/labelGroup.vue";
const baseUrl = process.env.VUE_APP_BASEURL;
export default {
  components: {
    modal,
    breadCrumb,
    pagination,
  },
  name: "contentCreate",
  data() {
    return {
      imgHost: "//image.healthjd.com/da/",
      formLabelAlign: {
        offLineValue: "",
      },
      title: "",
      indexTreeList: [],
      indexProps: {
        //索引下拉框配置
        multiple: true,
        value: "indexId",
        label: "name",
        children: "contentIndexes",
        checkStrictly: true,
      },
      contentId: "",
      time: "",
      articleId: "",
      contentIndexIds: [],
      deletearticleDialog: false,
      repealarticleDialog: false,
      repealoffLinearticleDialog: false,
      offLinearticleDialog: false,
      tableValue: "",
      mUrl: "",
      dialogVal: "接口返回内容",
      Width: "400px",
      articleDialog: false,
      dialogHeaderTitles: "",
      ShowBtn: [],
      DialogBtn: [],
      qrCode: "",
      inputVal: "",
      dialogTitles: "预览",
      btnText: [],
      dialogWidth: "722px",
      isShowBtn: [false, false],
      dialogPreVisible: false,
      previewDialog: false,
      // { 1:'图文', 2:'搭配', 3:'京装', 4:'帮助', 5:'单空间', 6:'整层', 7:'视频' }
      ArticleTypeList: [
        {
          articleType: -1,
          name: "全部类型",
        },
        {
          articleType: 1,
          name: "图文",
        },
        {
          articleType: 7,
          name: "视频",
        },
      ],
      ArticleStatusList: [
        { label: "全部状态", value: -1 },
        { label: "草稿", value: 1 },
        { label: "待审核", value: 2 },
        { label: "已发布", value: 3 },
        { label: "被驳回", value: 4 },
        { label: "已下线", value: 5 },
        { label: "待下线审核", value: 7 },
      ],

      auditStatus: -1,
      articleType: -1,
      contentAttributes: "",
      tableData: [],
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      baseUrl,
      qualityList: [],
      contentAttr: [],
      showSyncDialog: false, // 同步弹窗
      showDesyncDialog: false, // 不同步弹窗
      showTipHeader: false, // 顶部是否同步header
    };
  },
  created() {
    this.pageArticlesByPin();
    this.getIndexTreeList();
    this.queryDictionaries();
    const queryData = {
      tenantId: this.$commonJs.getTenantId(),
      syncPlaform: "jd_dr",
    };
    queryWriterHisSyncConfirm(queryData).then((res) => {
      if (res.syncHistoryAuthority && res.syncStatus == null) {
        // 显示headere
        const now = new Date();
        const nowDateString = now.toISOString().split("T")[0];

        // 从localStorage获取存储的日期字符串
        const storedDateString = localStorage.getItem("cancelDate");
        if (storedDateString) {
          // 将存储的日期转换为Date对象，然后增加一天
          const storedDate = new Date(storedDateString);
          storedDate.setDate(storedDate.getDate() + 1); // 增加一天
          const nextStoredDateString = storedDate.toISOString().split("T")[0];
          // 直接比较日期对象
          if (nowDateString >= nextStoredDateString) {
            console.log("当前时间大于等于存储时间的第二天");
            this.showTipHeader = true;
          } else {
            console.log("当前时间小于存储时间的第二天");
            this.showTipHeader = false;
          }
        } else {
          // 如果没有存储的日期，可以根据需要处理这种情况
          console.log("没有找到存储的日期");
          this.showTipHeader = true;
        }
      } else {
        // 不显示header
        this.showTipHeader = false;
        localStorage.removeItem(`cancelDate`);
      }
    });
  },
  filters: {
    articleStatus(data) {
      switch (data) {
        case 1:
          return "草稿";
        case 2:
          return "待审核";
        case 3:
          return "已发布";
        case 4:
          return "被驳回";
        case 5:
          return "已下线";
        case 6:
          return "冻结";
        case 7:
          return "待下线审核";
        case 8:
          return "已删除";
        default:
          return "";
      }
    },
    articlesType: function (data) {
      switch (data) {
        case 1:
          return "图文";
        case 2:
          return "搭配";
        case 3:
          return "京装";
        case 4:
          return "帮助";
        case 5:
          return "单空间";
        case 6:
          return "整层";
        case 7:
          return "视频";
        case 10:
          return "文章子文章";
      }
    },
  },
  methods: {
    // 内容质量
    changenture(val) {
      const arr = [{ code: val.code, type: val.type }];
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      this.contentAttr = arr;
      this.pageArticlesByPin();
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      // this.pageContentLabelGroups()
      this.pageArticlesByPin();
    },
    // 获取内容质量枚举
    queryDictionaries() {
      queryDictionaries({
        tenantId: this.$commonJs.getTenantId(),
        typeList: [29],
      }).then((res) => {
        console.log("res", res);
        if (res) {
          // let arr = res.map(item => {
          //   return {value: item.id, label: item.desc}
          // })
          // arr.unshift({value: 10000, label: "全部"})
          // that.select.map(item => {
          //   if (item.prop == 'quality') item.List = arr
          // })

          this.qualityList = [...this.qualityList, ...res];
          // console.log('qualityList', '来这了----->',that.qualityList);
        }
      });
    },
    copyUrl(content) {
      /**
       * 复制内容到粘贴板
       * content : 需要复制的内容
       * message : 复制完后的提示，不传则默认提示"复制成功"
       */
      const aux = document.createElement("input");
      aux.setAttribute("value", content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$message.success("复制成功");
    },
    getPreviewInfoByIdForPin(val, urlPre) {
      let urlAddress = "//beta-api.m.jd.com";
      let devUrl = "https://laputa-yf.jd.com/content/"; // 疾病症状预发地址
      let onlineUrl = "https://laputa.jd.com/content/";
      let newUrl;
      if (this.baseUrl === urlAddress) {
        // 预发
        newUrl = devUrl;
      } else {
        newUrl = onlineUrl;
      }
      newUrl = newUrl + urlPre + val.articleId;
      this.mUrl = newUrl;
      this.getQRCode(newUrl);
    },
    currentChange() {},
    // 预览
    articlePreview(val) {
      this.dialogPreVisible = true;
      this.previewDialog = true;

      this.getPreviewInfoByIdForPin(
        {
          tenantId: val.tenantId,
          articleId: val.id,
        },
        val.articleStatus == 3 ? "" : "preview/"
      );
    },
    // 修改
    articleAlter(row) {
      this.$router.push({
        path: `/article`,
        query: {
          id: row.id,
          articleType: row.articleType,
          articleStatus: row.articleStatus,
          labelGroupId: this.$route.query.labelGroupId || undefined,
        },
      });
    },
    //生成二维码
    getQRCode(val) {
      var opts = {
        errorCorrectionLevel: "H",
        type: "image/jpeg",
        rendererOpts: {
          quality: 0.3,
        },
      };

      QRCode.toDataURL(val, opts, (err, url) => {
        if (err) throw err;
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    changeType(val) {
      this.articleType = val;
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      this.pageArticlesByPin();
    },
    changeStatus(val) {
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      this.auditStatus = val;
      this.pageArticlesByPin();
    },
    selectChenge(val, a, b, c) {
      console.log(val, a, b, c);
      this.time = val;
      this.pageArticlesByPin();
    },
    handleChange(val) {
      console.log(val);
      this.contentIndexes = val;
      this.pageArticlesByPin();
    },
    searchId(val) {
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      this.articleId = val;
      this.pageArticlesByPin();
    },
    searchTitle(val) {
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      this.title = val;
      this.pageArticlesByPin();
    },
    recursionObj(node, callback, judge) {
      if (judge(node)) {
        node = callback(node);
      }
      if (!node.contentIndexes || node.contentIndexes.length === 0) {
        return;
      }
      for (let i = 0; i < node.contentIndexes.length; i++) {
        if (judge(node)) {
          this.recursionObj(node.contentIndexes[i], callback, () => true);
        } else {
          this.recursionObj(node.contentIndexes[i], callback, judge);
        }
      }
      return;
    },
    // 获取索引下拉数据
    getIndexTreeList() {
      writerContentIndexTree().then((res) => {
        // 处理树的叶子结点
        for (let i = 0; i < res.length; i++) {
          this.recursionObj(
            res[i],
            (curNode) => {
              curNode.contentIndexes = undefined;
              return curNode;
            },
            (node) => node.contentIndexes.length === 0
          );
        }
        setTimeout(() => {
          // 添加这段代码
          const $el = document.querySelectorAll(".el-cascader-node[aria-owns]");
          console.log($el);
          Array.from($el).map((item) => item.removeAttribute("aria-owns"));
        }, 300);
        this.indexTreeList = res;
      });
    },
    //获取用户的文章列表
    pageArticlesByPin() {
      let vm = this;
      let contentIndexIds = [];
      if (this.contentIndexIds.length > 0) {
        contentIndexIds = this.contentIndexIds.map(
          (item) => item[item.length - 1]
        );
      }
      pageArticlesByPin({
        tenantId: Number(vm.$commonJs.getTenantId()),
        articleType: vm.articleType, // Number(vm.articleType)
        auditStatus: vm.auditStatus, //Number(vm.auditStatus)
        contentAttributes: vm.contentAttr,
        articleId: vm.articleId,
        startSubmitTime: vm.time?.[0],
        endSubmitTime: vm.time?.[1],
        title: vm.title,
        contentIndexIds,
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      }).then((res) => {
        vm.tableData.splice(0, this.tableData.length);
        res.data.map((item) => {
          //
          vm.tableData.push(item);
        });

        vm.paginationDataProduct.total = res.totalCount;
        vm.paginationDataProduct.currentPage = res.pageNo;
        vm.paginationDataProduct.pageSize = res.pageSize;
      });
    },
    // 删除草稿
    deleteDraftForPinBut(val) {
      this.dialogHeaderTitles = "删除";
      (this.ShowBtn = [true, true]), (this.DialogBtn = ["取消", "确定"]);
      this.deletearticleDialog = true;
      this.tableValue = val;
    },
    deleteclickHandler(val) {
      if (val === "one") {
        this.deletearticleDialog = false;
      } else if (val === "two") {
        this.deleteDraftForPin(this.tableValue);
        this.deletearticleDialog = false;
      }
    },
    deleteDraftForPin(val) {
      let vm = this;
      deleteDraftForPin({
        tenantId: this.$commonJs.getTenantId(),
        articleId: Number(val.id),
      })
        .then((res) => {
          // setTimeout(()=>{
          this.$message.success("删除成功！");
          this.pageArticlesByPin();
          // },500)
        })
        .catch((err) => {
          this.$message.error("删除失败！");
        });
    },

    topWriterArticle(val) {
      const status = val.isTop === 1 ? 0 : 1;
      topWriterArticle({
        tenantId: this.$commonJs.getTenantId(),
        id: Number(val.id),
        isTop: status,
      }).then((result) => {
        if (result === true) {
          val.isTop = status;
          this.$message.info(status === 1 ? '置顶成功' : '取消置顶成功');
        } else {
          this.$message.info(status === 1 ? '文章已置顶' : '文章已取消置顶');
        }
      }).catch((error) => {
        if (error.code === "1806") {
          this.$message.error('置顶已满，请将现有置顶取消后重试');
        } else {
          this.$message.error(status === 1 ? '置顶失败，请重试' : '取消置顶失败，请重试');
        }
      });
    },
    // 同步
    syncClickHandler(val) {
      if (val === "one") {
        // 取消
        this.showSyncDialog = false;
      } else if (val === "two") {
        // 同步执行函数
        window.open(
          `https://dr.jd.com/page/registration.html?returnurl=%2Fpage%2Fapp.html%23%2Fhome`,
          "_blank"
        );
        this.showSyncDialog = false;
      }
    },
    // 不同步
    desyncClickHandler(val) {
      if (val === "one") {
        // 取消
        this.showDesyncDialog = false;
      } else if (val === "two") {
        // 不同步执行函数
        localStorage.removeItem(`cancelDate`);
        this.showTipHeader = false;
        const syncParam = {
          tenantId: this.$commonJs.getTenantId(),
          operationType: 9,
          operationTargetType: 7,
          operationTargetId: "jd_dr",
          operationStatus: 0,
        };
        saveSyncState(syncParam).then((res) => {
          this.showDesyncDialog = false;
        });
      }
    },

    // 下线
    applyOfflineForPinBut(val) {
      this.formLabelAlign.offLineValue = "";
      (this.ShowBtn = [true, true]), (this.DialogBtn = ["取消", "确定"]);
      this.offLinearticleDialog = true;
      this.tableValue = val;
    },
    offLineclickHandler(val) {
      if (val === "one") {
        this.offLinearticleDialog = false;
      } else if (val === "two") {
        if (this.formLabelAlign.offLineValue === "") {
          return this.$message.error("请输入下线理由");
        }
        this.applyOfflineForPin(this.tableValue);
        this.offLinearticleDialog = false;
      }
    },
    applyOfflineForPin(val) {
      let vm = this;
      if (this.formLabelAlign.offLineValue) {
        applyOfflineForPin({
          tenantId: this.$commonJs.getTenantId(),
          articleId: Number(val.id),
          remark: this.formLabelAlign.offLineValue,
          auditStatus: 7,
        })
          .then((res) => {
            this.pageArticlesByPin();
            this.$message.success("申请成功！");
          })
          .catch((err) => {
            this.$message.error("申请下线失败,请稍后再试");
          });
      } else {
        this.$message.error("请输入理由");
      }
    },
    //撤销申请下线
    cancelApplyOfflineForPinBut(val) {
      (this.ShowBtn = [true, true]), (this.DialogBtn = ["取消", "确定"]);
      this.repealoffLinearticleDialog = true;
      this.tableValue = val;
    },
    repealoffLineclickHandler(val) {
      if (val === "one") {
        this.repealoffLinearticleDialog = false;
      } else if (val === "two") {
        this.cancelApplyOfflineForPin(this.tableValue);
        this.repealoffLinearticleDialog = false;
      }
    },
    cancelApplyOfflineForPin(val) {
      let vm = this;
      cancelApplyOfflineForPin({
        tenantId: this.$commonJs.getTenantId(),
        articleId: Number(val.id),
        auditStatus: 3,
      })
        .then((res) => {
          if (res === 1) {
            this.pageArticlesByPin();
            this.$message({
              message: "撤销申请下线成功",
              type: "success",
            });
          }
        })
        .catch((err) => {
          this.$message.error("撤销申请下线失败,请稍后再试");
        });
    },
    // 撤销投稿
    cancelApplyArticleForPinBut(val) {
      (this.ShowBtn = [true, true]), (this.DialogBtn = ["取消", "确定"]);
      this.tableValue = val;
      this.repealarticleDialog = true;
    },
    repealclickHandler(val) {
      if (val === "one") {
        this.repealarticleDialog = false;
      } else if (val === "two") {
        this.cancelApplyArticleForPin(this.tableValue);
        this.repealarticleDialog = false;
      }
    },
    cancelApplyArticleForPin(val) {
      let vm = this;
      cancelApplyArticleForPin({
        tenantId: this.$commonJs.getTenantId(),
        articleId: Number(val.id),
        auditStatus: 1,
      }).then((res) => {
        this.pageArticlesByPin();
      });
    },
    // toTarget() {
    // window.open(this.mUrl)
    // },
    resetSelectVal() {
      this.articleType = -1;
      this.auditStatus = -1;
      this.time = [];
      this.title = "";
      this.articleId = "";
      this.contentIndexIds = [];
      this.contentAttributes = "";
      this.contentAttr = [];
      this.pageArticlesByPin();
    },
    handleSync() {
      const params = {
        tenantId: this.$commonJs.getTenantId(),
        syncDr: true,
      };
      queryContentUserMapping(params)
        .then((res) => {
          if (res.id) {
            // 已认证正常请求
            const syncParam = {
              tenantId: this.$commonJs.getTenantId(),
              operationType: 9,
              operationTargetType: 7,
              operationTargetId: "jd_dr",
              operationStatus: 1,
            };
            saveSyncState(syncParam).then((res) => {
              this.$message.success("同步成功");
              this.showTipHeader = false;
              console.log("同步");
            });
          } else {
            (this.ShowBtn = [true, true]),
              (this.DialogBtn = ["取消", "去认证"]);
            this.showSyncDialog = true;
          }
        })
        .catch((err) => {
          // 未认证需要认证
          console.log("去认证？", err);
          (this.ShowBtn = [true, true]), (this.DialogBtn = ["取消", "去认证"]);
          this.showSyncDialog = true;
        });
    },
    handleDesync() {
      (this.ShowBtn = [true, true]), (this.DialogBtn = ["取消", "确认"]);
      this.showDesyncDialog = true;
    },
    handleDailyCancel() {
      const now = new Date();
      const isoDate = now.toISOString();
      const currentDate = isoDate.split("T")[0];
      localStorage.setItem(`cancelDate`, currentDate);
      this.showTipHeader = false;
    },
  },
};
</script>

<style scoped lang="scss">
.red {
  color: red;
}
.paddingLeft {
  padding: 15px 0;
  padding-left: 30px;
}
.content-main {
  width: 100%;
  padding: 30px;
  font-size: 16px;
  text-align: center;
}
.tipHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #eff0f4;
  height: 50px;
  font-size: 15px;
  //font-family: PingFangSC-Medium, sans-serif;
  font-weight: 300;
  padding: 15px;
  color: #939496;
  .tipBtns {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #409eff;
    & > * {
      cursor: pointer;
      margin-left: 12px;
    }
  }
  .closeBtn {
    color: #939496;
    cursor: pointer;
    margin-top: -25px; /* 如果需要，调整此值以确保按钮紧贴上边缘 */
    margin-left: 20px;
  }
}
.content-manage {
  position: relative;
  padding: 22px 30px;
  width: 100%;
  background: #fff;
  .title {
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: rgba(38, 38, 38, 1);
  }
  .content-tabs {
    margin-top: 2px;
    .el-tabs__header {
      margin: 0 0 0px;
    }
    .el-tabs__item {
      padding: 0 18px;
      height: 52px;
      line-height: 52px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: rgba(38, 38, 38, 1);
      &.is-active {
        color: rgba(255, 110, 0, 1);
      }
    }
    .el-tabs__active-bar {
      background-color: #ff6e00;
    }
    .el-tabs__nav-wrap::after {
      content: "";
      background-color: transparent;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    border: 1px solid rgba(227, 232, 235, 1);
    position: absolute;
    left: 0;
    top: 99px;
  }
  &-header {
    background-color: white;
    height: 60px;
    /*line-height: 60px;*/
    padding: 0 15px 0;
    border-radius: 3px;
    display: flex;
    align-items: center;
    &-type,
    &-status,
    &-input {
      margin-left: 10px;
      width: 220px;
      min-height: 32px;
      float: left;
      :deep(el-input__inner el-input--mini) {
        height: 32px;
        line-height: 32px;
      }
    }
    &-type {
      :deep(.el-input__inner::-webkit-input-placeholder) {
        color: #636569;
      }
    }
    &-status {
      margin-left: 15px;
    }
    &-button {
      width: 88px;
      height: 32px;
      background-color: #f8fafc;
      margin-left: auto;
      color: #9ca8b9;
    }
  }
  &-list {
    background-color: white;
    padding: 20px;
    margin-top: 15px;
    border-radius: 3px;
    &-table {
      border: solid 1px #e7eff8;
      border-bottom: none;
      :deep(.el-table thead th) {
        height: 54px;
        font-size: 14px;
        padding: 0px 10px 0px 10px;
        color: #5d6072;
        font-weight: bold;
        background: #fafbfd !important;
      }
      :deep(.el-table__body td),
      :deep(.el-table__body th) {
        height: 48px;
        padding: 0px 10px 0px 10px;
        color: #757575;
        font-size: 12px;
      }
      .border {
        margin: 0 5px 0;
        display: inline-block;
        height: 6px;
        width: 1px;
        /*background-color: black;*/
        border: 0.9px solid #266cee;
      }
      .delete {
        color: #f62458;
      }
    }
    &-page {
      margin-top: 20px;
      text-align: right;
      :deep(el-pagination__total) {
        color: #768597;
      }
      .page {
        margin-top: 20px;
        :deep(&.is-background .el-pager li:not(.disabled).active) {
          background: #266cee;
          font-size: 12px;
          color: #ffffff;
        }
      }
    }
  }
}
.dialog-input {
  width: 558px;
}
.color {
  color: #2c3443 !important;
  margin-left: 24px;
}
.dislog-sub-title {
  color: #8b8c9a;
  font-size: 12px;
  margin-top: 14px;
}
.image {
  margin-top: 20px;
}
.qrCode {
  width: 182px;
  height: 182px;
  margin: 60px auto;
  margin-bottom: 0px;
}
.img-des {
  margin: 0 auto;
  width: 182px;

  text-align: center;
}
.dialog-conter {
  padding: 34px;
  padding-top: 20px;
  padding-bottom: 20px;
  .dialog-header {
    font-size: 14px;
    font-weight: 600;
  }
  .dialog-conter-conter {
    min-height: 100px;
    margin-top: 20px;
  }
}
// 下拉框
.el-select-dropdown__item {
  font-size: 14px;
  font-weight: 100 !important;
}

.el-select-dropdown__item.selected,
.el-select-dropdown__item.hover {
  font-size: 14px;
  color: #266cee;
  font-weight: 100 !important;
}
:deep(.el-textarea__inner) {
  // height: 100%;
  min-height: 100px !important;
}
</style>
